<li class="nav-item dropdown-notification mr-25" ngbDropdown>
    <a class="nav-link" ngbDropdownToggle id="navbarApprovalDropdown"><i class="ficon"
            data-feather="check-square"></i><span class="badge badge-pill badge-danger badge-up"
            *ngIf="totalCount > 0">{{ totalCount }}</span></a>

    <ul ngbDropdownMenu aria-labelledby="navbarApprovalDropdown"
        class="dropdown-menu dropdown-menu-media dropdown-menu-right approval-dropdown">
        <li class="dropdown-menu-header">
            <div class="dropdown-header d-flex">
                <h4 class="notification-title mb-0 mr-auto">Approvals</h4>
                <div class="badge badge-pill badge-light-primary" *ngIf="totalCount > 0">
                    {{ totalCount }} New
                </div>
            </div>
        </li>

        <li class="scrollable-container media-list" [ngClass]="{'py-2': totalCount === 0}">
            <ng-container *ngFor="let item of approvals">
                <ng-container *ngIf="item.count > 0">
                    <a class="d-flex" (click)="navigate(item)" *renderIf="{ roles: ['employee'], right: item.right }">

                        <div class="media d-flex align-items-start">
                            <img [src]="item.icon" alt="icon" class="mr-1" width="20" height="20" />
                            <div class="media-body">
                                <p class="media-heading mb-0 hover:text-primary">{{ item.title }}</p>
                            </div>
                            <span class="badge badge-primary ml-auto">
                                {{ item.count }}
                            </span>
                        </div>
                    </a>
                </ng-container>
            </ng-container>

            <h4 class="text-center mb-0" *ngIf="loading || totalCount === 0">
                <span class="text-muted" *ngIf="!loading && totalCount === 0">
                    No Pending Approvals.
                </span>
                <span class="spinner-border text-primary" *ngIf="loading"></span>
            </h4>
        </li>

        <li class="dropdown-menu-footer">
        </li>
    </ul>
</li>